/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentSkillLevelOption
 */
export interface TournamentSkillLevelOption {
    /**
     * Internal key (e.g., OPEN, BEGINNER, PRO)
     * @type {string}
     * @memberof TournamentSkillLevelOption
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentSkillLevelOption
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentSkillLevelOption
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentSkillLevelOption
     */
    sortOrder: number;
}

/**
 * Check if a given object implements the TournamentSkillLevelOption interface.
 */
export function instanceOfTournamentSkillLevelOption(value: object): value is TournamentSkillLevelOption {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function TournamentSkillLevelOptionFromJSON(json: any): TournamentSkillLevelOption {
    return TournamentSkillLevelOptionFromJSONTyped(json, false);
}

export function TournamentSkillLevelOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentSkillLevelOption {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'enabled': json['enabled'],
        'sortOrder': json['sortOrder'],
    };
}

export function TournamentSkillLevelOptionToJSON(json: any): TournamentSkillLevelOption {
    return TournamentSkillLevelOptionToJSONTyped(json, false);
}

export function TournamentSkillLevelOptionToJSONTyped(value?: TournamentSkillLevelOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'enabled': value['enabled'],
        'sortOrder': value['sortOrder'],
    };
}

